
export enum PaymentOptions {
  SEPA = "SEPA",
  CREDIT_CARDS_AND_WALLET = "CREDIT_CARDS_AND_WALLET",
  //Paypal, Adyen etc. maybe in the future
}
